'use strict';

angular.module('paizacloudApp')
  .directive('containertabwm', function($timeout, $filter) {
    return {
      template: require('./containerTabwm.directive.html').default,
      restrict: 'EA',
      scope: {
        container: '=',
        controller: '=',
        onRemove: '&',
        windowModels: '=',
      },
      link: function(scope, element, attrs) {
        scope.activeTab = null;
        if($filter('tabWindowModelFilter')(scope.windowModels).length > 0){
          scope.activeTab = $filter('tabWindowModelFilter')(scope.windowModels)[0];
        }

        $timeout(() => {
          scope.ready = true;
        }, 100);

        scope.activeSidebarTab = null;
        scope.sidebarWidth = 200;
        scope.$watch('activeSidebarTab', function(post, pre){
          if(post === pre){
            return;
          }
          scope.$broadcast('resize', event);
          $timeout(function(){
            scope.$broadcast('resize', event);
          }, 500);
        });

        scope.showApplicationMenu = (event, self) => {
          scope.$broadcast('showApplicationMenu', event, self);
        };

        scope.close = (windowModel) => {
          scope.controller.deleteWindowModel(windowModel);
        };
        /*
        $timeout(function(){
          var sidebarElement = $("sidebar")[0];
          sidebarElement.addEventListener("webkitTransitionEnd", function(event){
            console.log(".sidebar-wrap transitionend:", event);
            scope.$broadcast('resize', event);

          });
          */
          /*
        element.find("sidebar").on("webkitTransitionEnd", function(event){
          console.log(".sidebar-wrap transitionend:", event);
          scope.$broadcast('resize', event);
        });
        }, 1000);
          */
        scope.onDividerMove = function(event){
          console.log('onDividerMove', event);
          scope.$broadcast('resize', event);
        };
        scope.isActive = function(tab){
          return tab !== null;
        };

        scope.windowModels.forEach(function(windowModel){
          windowModel.maximize = true;
        });
        if(scope.windowModels[0]){
          scope.container.activateWindowModel(scope.windowModels[0]);
        }

        /*
        scope.selectWindow = function (ev){
          scope.$broadcast('focus', ev);
        };
        */

        {
          let cb;

          window.addEventListener("resize", cb = function(e){
            scope.$broadcast('resize', e);
          }, true);
          scope.$on('$destroy', function(){
            window.removeEventListener("resize", cb, true);
          });
        }

        scope.$on('resize view', function(event, width, height){
          // scope.$broadcast('resize', event);
        });

        scope.$watch('container.activeWindow', function(post, pre){
          console.log('watch(container.activeWindow) function called.');
          let i = $filter('tabWindowModelFilter')(scope.windowModels).indexOf(scope.container.activeWindow);
          console.log("aaa");
          if(i >= 0){
            $timeout(function(){
              // scope.activeTab = i;
              console.log("hoge");
              scope.activeTab = scope.container.activeWindow;
              console.log("fuga");
            });
          }
        });
      },
    };
  });
